<!-- External Entity Maintenance Component Template - Angular 12 -->
<div class="modal-header">
    <h3 class="modal-title">
      {{ title }}
      <i (click)="cancel()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
      <i class="fa pull-right" 
         [ngClass]="{'fa-plus-square-o': minimized, 'fa-minus-square-o': !minimized}" 
         style="margin-right: 10px; cursor: pointer;" 
         (click)="minimized = !minimized"></i>
    </h3>
  </div>
  
  <div class="modal-body" [formGroup]="extEntityForm" [hidden]="minimized">
  
    <!-- Type of Entity Selection -->
    <table class="table table-no-border">
      <tr>
        <td width="10%" style="border-top-width:0px !important;">
          Type of Entity:<span class="required-asterisk">*</span>
        </td>
        <td style="border-top-width:0px !important;">
          Company&nbsp;&nbsp;
          <input type="radio" formControlName="COMP_PER" value="C" id="comp_c">
          <label for="comp_c">&nbsp;</label>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Person&nbsp;&nbsp;
          <input type="radio" formControlName="COMP_PER" value="P" id="comp_p">
          <label for="comp_p">&nbsp;</label>
        </td>
      </tr>
  
      <!-- Entity Name (for Company) -->
      @if (isCompany) {
<tr>
        <td width="10%" style="border-top-width:0px !important;">
          Entity Name:<span class="required-asterisk">*</span>
        </td>
        <td style="border-top-width:0px !important;">
          <input type="text" 
                 maxlength="150" 
                 formControlName="ENTITY_PERSON_NAME" 
                 style="width:450px;" 
                 class="form-control input-sm"
                 [class.is-invalid]="hasError('ENTITY_PERSON_NAME', 'required')"/>
        </td>
      </tr>
}
  
      <!-- EIN (for Company) -->
      @if (isCompany) {
<tr>
        <td width="10%" style="border-top-width:0px !important;">
          EIN:@if (isUSCountry) {
<span class="required-asterisk">*</span>
}
        </td>
        <td width="90%" style="border-top-width:0px !important;">
          <table>
            <tr>
              <td style="padding-left:0px !important;">
                <input type="text" 
                       maxlength="9" 
                       formControlName="SSN_EIN" 
                       style="width:90px;" 
                       class="form-control input-sm numText" 
                       appOnlyDigits
                       [class.is-invalid]="hasError('SSN_EIN', 'required') || hasError('SSN_EIN', 'minlength')"/>
              </td>
              <td>&nbsp;&nbsp;Applied For&nbsp;&nbsp;
                <input type="radio" 
                       name="ssnEinType" 
                       (change)="extEntityForm.patchValue({SSN_EIN: 'APPLD FOR'})"
                       [checked]="getFormControl('SSN_EIN')?.value === 'APPLD FOR'">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </td>
              <td>Foreign US&nbsp;&nbsp;
                <input type="radio" 
                       name="ssnEinType" 
                       (change)="extEntityForm.patchValue({SSN_EIN: 'FOREIGNUS'})"
                       [checked]="getFormControl('SSN_EIN')?.value === 'FOREIGNUS'">
              </td>
            </tr>
          </table>
        </td>
      </tr>
}
    </table>
  
    <!-- Disregarded Entity Checkbox (for Company) -->
    @if (isCompany) {
<table class="table table-no-border">
      <tr>
        <td width="15%" style="border-top-width:0px !important;">
          Check here if disregarded entity:
        </td>
        <td style="border-top-width:0px !important;">
          <input type="checkbox"
                 [checked]="extEntityForm.get('DISREGARDED')?.value === 'Y'"
                 (change)="onDisregardedChange($event)"/>
        </td>
      </tr>
    </table>
}
  
    <table class="table table-no-border">
      <!-- Home Office Entity (for disregarded companies) -->
      @if (isCompany && isDisregarded) {
<tr>
        <td width="10%" style="border-top-width:0px !important;">
          Home Office Entity:<span class="required-asterisk">*</span>
        </td>
        <td style="border-top-width:0px !important;">
          <select style="width:550px;" 
                  formControlName="ho_le" 
                  class="form-control"
                  (change)="onHomeOfficeChange($event)"
                  [class.is-invalid]="hasError('ho_le', 'required')">
            <option value="">Select Home Office</option>
            @for (hole of holeList; track $index) {
<option [value]="hole.HO_CODE">
              {{ hole.HO_DESC }}
            </option>
}
          </select>
        </td>
      </tr>
}
  
      <!-- Home Office EIN (for disregarded companies) -->
      @if (isCompany && isDisregarded) {
<tr>
        <td width="10%" style="border-top-width:0px !important;">
          Home Office EIN:
        </td>
        <td style="border-top-width:0px !important;">
          <input type="text" 
                 maxlength="9" 
                 formControlName="HO_EIN" 
                 style="width:90px;" 
                 readonly 
                 class="form-control input-sm"/>
        </td>
      </tr>
}
  
      <!-- Person Name (for Person) -->
      @if (!isCompany) {
<tr>
        <td width="10%" style="border-top-width:0px !important;">
          Person Name:<span class="required-asterisk">*</span>
        </td>
        <td style="border-top-width:0px !important;">
          <input type="text" 
                 maxlength="35" 
                 formControlName="PERSON_NAME" 
                 style="width:290px;" 
                 class="form-control input-sm"
                 [class.is-invalid]="hasError('PERSON_NAME', 'required')"/>
        </td>
      </tr>
}
  
      <!-- SSN (for Person) -->
      @if (!isCompany) {
<tr>
        <td width="10%" style="border-top-width:0px !important;">
          SSN:@if (isUSCountry) {
<span class="required-asterisk">*</span>
}
        </td>
        <td style="border-top-width:0px !important;">
          <input type="number" 
                 maxlength="9" 
                 formControlName="SSN" 
                 style="width:90px;" 
                 class="form-control input-sm numText" 
                 appOnlyDigits
                 [class.is-invalid]="hasError('SSN', 'required') || hasError('SSN', 'minlength')"/>
        </td>
      </tr>
}
  
      <!-- Entity Type -->
      <tr>
        <td width="10%" style="border-top-width:0px !important;">
          Entity Type:<span class="required-asterisk">*</span>
        </td>
        <td style="border-top-width:0px !important;">
          <select formControlName="LE_TYPE" 
                  style="width:23%" 
                  class="form-control"
                  [class.is-invalid]="hasError('LE_TYPE', 'required')">
            <option value="">Select Entity Type</option>
            @for (entityType of entityTypeList; track $index) {
<option [value]="entityType.LE_TYPE_CODE">
              {{ entityType.LE_TYPE }}
            </option>
}
          </select>
        </td>
      </tr>
    </table>
  
    <!-- Retirement Plan Checkbox -->
    <table class="table table-no-border">
      @if (!isDisregarded) {
<tr>
        <td width="15%" style="border-top-width:0px !important;">
          Is the partner a retirement plan like IRA/SEP/Keogh/etc.?
        </td>
        <td style="border-top-width:0px !important;">
          <input type="checkbox"
                 [checked]="extEntityForm.get('RETIRE_PLAN_KEY')?.value === '1'"
                 (change)="onRetirePlanChange($event)"/>
        </td>
      </tr>
}
    </table>
  
    <!-- Type of Eligible Partner -->
    <table class="table table-no-border">
      @if (!isDisregarded) {
<tr>
        <td width="10%" style="border-top-width:0px !important;">
          Type of Eligible Partner (1065 Schedule B2 Part 1)
        </td>
        <td style="border-top-width:0px !important;">
          Individual&nbsp;&nbsp;
          <input type="radio" formControlName="TYPE_OF_ENTITY_KEY" value="I">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Corporation&nbsp;&nbsp;
          <input type="radio" formControlName="TYPE_OF_ENTITY_KEY" value="C">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Estate of Deceased Partner&nbsp;&nbsp;
          <input type="radio" formControlName="TYPE_OF_ENTITY_KEY" value="E">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Eligible Foreign Entity&nbsp;&nbsp;
          <input type="radio" formControlName="TYPE_OF_ENTITY_KEY" value="F">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          S corporation&nbsp;&nbsp;
          <input type="radio" formControlName="TYPE_OF_ENTITY_KEY" value="S">
        </td>
      </tr>
}
  
      <!-- Address Country -->
      <tr>
        <td width="10%" style="border-top-width:0px !important;">
          Address Country:
        </td>
        <td style="border-top-width:0px !important;">
          <select formControlName="COUNTRY_NAME" 
                  style="width:30%" 
                  class="form-control">
            <option value="">Select Country</option>
            @for (country of countryList; track $index) {
<option 
                    [value]="country.CODE_SHORT_DESC + ' - ' + country.CODE_DESCRIPTION">
              {{ country.CODE_SHORT_DESC }} - {{ country.CODE_DESCRIPTION }}
            </option>
}
          </select>
        </td>
      </tr>
  
      <!-- Address Line 1 -->
      <tr>
        <td width="10%" style="border-top-width:0px !important;">
          Address Line 1:@if (getFormControl('COUNTRY_NAME')?.value) {
<span class="required-asterisk">*</span>
}
        </td>
        <td style="border-top-width:0px !important;">
          <input type="text" 
                 maxlength="135" 
                 formControlName="REG_ADDRESS_LINE1" 
                 style="width:950px;" 
                 class="form-control input-sm"
                 [class.is-invalid]="hasError('REG_ADDRESS_LINE1', 'required')"/>
        </td>
      </tr>
  
      <!-- Address Line 2 -->
      <tr>
        <td width="10%" style="border-top-width:0px !important;">
          Address Line 2:
        </td>
        <td style="border-top-width:0px !important;">
          <input type="text" 
                 maxlength="135" 
                 formControlName="REG_ADDRESS_LINE2" 
                 style="width:950px;" 
                 class="form-control input-sm"/>
        </td>
      </tr>
  
      <!-- City -->
      <tr>
        <td width="10%" style="border-top-width:0px !important;">
          City:@if (getFormControl('COUNTRY_NAME')?.value) {
<span class="required-asterisk">*</span>
}
        </td>
        <td style="border-top-width:0px !important;">
          <input type="text" 
                 [maxlength]="isUSCountry ? 22 : 50"
                 formControlName="REG_ADDRESS_CITY" 
                 [style.width]="isUSCountry ? '180px' : '380px'"
                 class="form-control input-sm"
                 [class.is-invalid]="hasError('REG_ADDRESS_CITY', 'required')"/>
        </td>
      </tr>
  
      <!-- State -->
      <tr>
        <td width="10%" style="border-top-width:0px !important;">
          @if (isUSCountry) {
<span>State:<span class="required-asterisk">*</span></span>
}
          @if (!isUSCountry) {
<span>State / Province:</span>
}
        </td>
        <td style="border-top-width:0px !important;">
          <!-- US States Dropdown -->
          @if (isUSCountry) {
<select 
                  formControlName="STATE_NAME" 
                  style="width:15%" 
                  class="form-control"
                  [class.is-invalid]="hasError('STATE_NAME', 'required')">
            <option value="">Select State</option>
            @for (state of stateList; track $index) {
<option [value]="state.CODE + ' - ' + state.NAME">
              {{ state.CODE }} - {{ state.NAME }}
            </option>
}
          </select>
}
          
          <!-- Non-US State Input -->
          @if (!isUSCountry) {
<input 
                 type="text" 
                 maxlength="17" 
                 formControlName="REG_ADDRESS_STATE" 
                 style="width:150px;" 
                 class="form-control input-sm"/>
}
        </td>
      </tr>
  
      <!-- Postal/Zip Code -->
      <tr>
        <td width="10%" style="border-top-width:0px !important;">
          Postal / Zip Code:@if (isUSCountry) {
<span class="required-asterisk">*</span>
}
        </td>
        <td style="border-top-width:0px !important;">
          <input type="number" 
                 [maxlength]="isUSCountry ? 9 : 16"
                 formControlName="REG_ADDRESS_ZIP" 
                 [style.width]="isUSCountry ? '80px' : '130px'"
                 class="form-control input-sm numText" 
                 appOnlyDigitsString
                 [class.is-invalid]="hasError('REG_ADDRESS_ZIP', 'required')"/>
        </td>
      </tr>
    </table>
  
    <!-- Mandatory Fields Note -->
    <table class="table table-no-border">
      <tr>
        <td style="border-top-width:0px !important;">
          <span class="required-asterisk">*</span> - <b>Mandatory Fields</b>
        </td>
      </tr>
    </table>
  
  </div>
  
  <!-- Modal Footer -->
  <div class="modal-footer">
    <button class="btn btn-info btn-sm" 
            type="button" 
            (click)="save()" 
            [disabled]="isSaveClicked"> 
            <!-- || extEntityForm.invalid -->
      @if (isSaveClicked) {
<span>
        <i class="fa fa-spinner fa-pulse"></i>
      </span>
}
      Save
    </button>
    @if (isNew) {
<button 
            class="btn btn-danger-outline btn-sm" 
            type="button" 
            (click)="reset()">
      Reset
    </button>
}
    <button class="btn btn-warning btn-sm" 
            type="button" 
            (click)="cancel()">
      Cancel
    </button>
  </div>